import { Box, CircularProgress } from '@mui/material';
import { Check as CheckIcon, Error as ErrorIcon } from '@mui/icons-material';

const FieldSavingIndicator = ({ status }) => {
  if (!status || status === 'idle') return null;

  return (
    <Box
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        ml: 1,
        verticalAlign: 'middle',
      }}
    >
      {status === 'saving' && (
        <CircularProgress size={16} sx={{ color: 'primary.main' }} />
      )}
      {status === 'saved' && (
        <CheckIcon sx={{ fontSize: 18, color: 'success.main' }} />
      )}
      {status === 'error' && (
        <ErrorIcon sx={{ fontSize: 18, color: 'error.main' }} />
      )}
    </Box>
  );
};

export default FieldSavingIndicator;
